import { render, staticRenderFns } from "./MiscQuoteDetail.vue?vue&type=template&id=0826f898&scoped=true"
import script from "./MiscQuoteDetail.vue?vue&type=script&lang=js"
export * from "./MiscQuoteDetail.vue?vue&type=script&lang=js"
import style0 from "./MiscQuoteDetail.vue?vue&type=style&index=0&id=0826f898&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826f898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0826f898')) {
      api.createRecord('0826f898', component.options)
    } else {
      api.reload('0826f898', component.options)
    }
    module.hot.accept("./MiscQuoteDetail.vue?vue&type=template&id=0826f898&scoped=true", function () {
      api.rerender('0826f898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/miscquote/MiscQuoteDetail.vue"
export default component.exports